import Swal from "sweetalert2";

const PopupOk = (width, icon, text) => {
  const config = {
    position: "center",
    heightAuto: true,
    icon: icon,
    title: text,
    showConfirmButton: false,
    timer: 1500,
  };
  
  // Solo agregar width si se proporciona
  if (width) {
    config.width = width;
  }
  
  return Swal.fire(config);
};

export default PopupOk;
